import { Model } from 'src/containers/ProjectDiagram/types/model';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { setRangesForAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/setRangesForAttributeModelData';
import { addProjectModelIdsToIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { setPropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/setPropertyType';

export const addAttribute =
  ({
    value,
    text,
    ranges,
    projectModelIds,
  }: {
    value: string;
    text: string;
    ranges: Array<{ value: string }>;
    projectModelIds: string[];
  }) =>
  (model: Model) => {
    setRangesForAttributeModelData(
      value,
      ranges.map((range) => range.value)
    )(model);
    setLabelForIri(value, text)(model);
    setPropertyType(value)(model);
    addProjectModelIdsToIri(value, projectModelIds)(model);
  };
